import React, { useState } from "react";
import DownChevIcon from "../../assets/svgIcons/down-chev-icon.svg";
import AddCircleIcon from "../../assets/svgIcons/add-circle-icon.svg";
import UserIcon from "../../assets/svgIcons/user-icon.svg";
import { Button } from "./design-system/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./design-system/Dropdown";
import DropboxAccountReady from "./DropboxAccountReady";
import type { IntegrationAPIResponse } from "../IntegrationModal";
import { getAccountIdentifier } from "../../utils/helper-functions";

export default function AccountDropdown({
  dataSources,
  handleAccountChange,
  handleAddAccountClick,
  selectedDataSource,
}: {
  dataSources: IntegrationAPIResponse[];
  selectedDataSource: IntegrationAPIResponse | null;
  handleAddAccountClick: () => Promise<void>;
  handleAccountChange: (id: number) => void;
}) {
  const [isDropboxAccountReady, setIsDropboxAccountReady] =
    useState<boolean>(false);

  const commonMenuConponent = () => {
    return (
      <DropdownMenuContent align="end" className="cc-w-[232px] ">
        <DropdownMenuGroup>
          {dataSources.map((dataSource) => {
            return (
              <DropdownMenuItem
                className="cc-border-b cc-border-outline-base_em hover:cc-bg-surface-surface_1 dark:cc-border-b-dark-border-color"
                key={dataSource.id}
                onClick={() => handleAccountChange(dataSource.id)}
              >
                <div>
                  <p className="cc-text-xs cc-font-semibold cc-text-high_em dark:cc-text-dark-text-white">
                    {getAccountIdentifier(dataSource, true)}
                  </p>
                </div>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="hover:cc-bg-surface-surface_1"
          onClick={async () => handleAddAccountClick()}
        >
          <p className="cc-text-xs cc-font-semibold cc-text-info_em cc-flex-grow">
            Add Account
          </p>
          <img
            alt="Add Circle Icon"
            className="cc-h-[18px] cc-w-[18px]"
            src={AddCircleIcon}
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    );
  };

  return (
    <>
      <DropboxAccountReady
        isOpen={isDropboxAccountReady}
        onOpenChange={setIsDropboxAccountReady}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className="cc-font-semibold cc-px-0 cc-gap-3 sm:cc-min-w-[180px] cc-rounded-xl sm:cc-hidden cc-shrink-0 "
            variant="gray"
          >
            <img
              alt="User Icon"
              className="cc-h-[18px] cc-w-[18px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
              src={UserIcon}
            />
          </Button>
        </DropdownMenuTrigger>
        {commonMenuConponent()}
      </DropdownMenu>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className="cc-font-semibold cc-px-3 cc-gap-3 sm:cc-min-w-[180px] cc-rounded-xl cc-hidden sm:cc-flex cc-shrink-0 cc-z-[2000]"
            variant="gray"
          >
            <span className="cc-flex-grow cc-text-left dark:cc-text-dark-text-white">
              {getAccountIdentifier(selectedDataSource)}
            </span>
            <img
              alt="Down Chev Icon"
              className="cc-h-[18px] cc-w-[18px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
              src={DownChevIcon}
            />
          </Button>
        </DropdownMenuTrigger>
        {commonMenuConponent()}
      </DropdownMenu>
    </>
  );
}
